import { getMappedEnv } from '@atlassian/atlassian-studio-env-utils';

const V2_STUDIO_DOMAIN = 'studio-next.';

let isV2: boolean | undefined;
export const isStudioV2 = (): boolean => {
	if (isV2 !== undefined) {
		return isV2;
	}

	isV2 =
		window.location.hostname.startsWith(V2_STUDIO_DOMAIN) ||
		(getMappedEnv() === 'local' && localStorage.getItem('studio-app-v2') === 'true');
	return isV2;
};
